"use strict";

$(document).ready(function () {
  var homepageGlide = $('.carousel.home');
  var homepageGlideNumberofSlides = document.querySelector('.glide-container');
  if (homepageGlide && homepageGlideNumberofSlides) {
    if (homepageGlideNumberofSlides.dataset.numberofslides > 1) {
      new Glide('.carousel.home', {
        type: 'carousel',
        autoplay: 7000,
        startAt: 0,
        perView: 1
      }).mount();
    }
  }
  var carouselContainers = $(".slider-container");
  if (carouselContainers) {
    carouselContainers.each(function () {
      var $this = $(this);
      var carousel = $this.find(".page-carousel");
      var pageSize = carousel.data("pagesize");
      new Glide(carousel[0], {
        type: 'carousel',
        startAt: 0,
        perView: pageSize,
        breakpoints: {
          768: {
            perView: 1
          }
        }
      }).mount();
    });
  }
  var serviceLineContainer = $(".service-line-slider-container");
  if (serviceLineContainer) {
    var serviceLineCarousel = serviceLineContainer.find(".service-line-page-carousel");
    var servicePageSize = serviceLineCarousel.data("pagesize");
    new Glide(serviceLineCarousel[0], {
      type: 'carousel',
      startAt: 0,
      perView: servicePageSize,
      breakpoints: {
        768: {
          perView: 1
        }
      }
    }).mount();
  }
  var numSlides = $(".glide-container .glide__slide");
  if (numSlides.length === 1) {
    $(".glide-container .nav-container").hide();
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var splideContainer = document.querySelector('.splide-container');
  if (splideContainer) {
    var main = new Splide('#main-carousel', {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
      focus: "center",
      cover: true,
      width: 900,
      fixedWidth: 900,
      breakpoints: {
        640: {
          width: 360,
          fixedWidth: 360
        }
      }
    });
    var mediaquery = window.matchMedia("(max-width: 768px)");
    if (!mediaquery.matches) {
      var thumbnails = new Splide("#vertical-slider", {
        width: 250,
        height: 600,
        direction: "ttb",
        isNavigation: true,
        fixedWidth: 250,
        fixedHeight: 160,
        pagination: false,
        cover: true,
        focus: "center",
        breakpoints: {
          768: {
            destroy: 'completely'
          }
        }
      });
      main.sync(thumbnails);
      main.mount();
      thumbnails.mount();
    }
    if (mediaquery.matches) {
      main.mount();
    }
  }
});